import React from 'react';
import { Link } from 'react-router-dom';
import Button from './elements/Button';
import {
  getConsent,
  setConsent,
  OPEN_COOKIE_SETTINGS_EVENT
} from '../utils/consent';
import {
  enableAnalyticsConsent,
  disableAnalyticsConsent
} from '../utils/analytics';

class ConsentBanner extends React.Component {
  state = {
    visible: false
  };

  componentDidMount() {
    this.syncVisibility();
    window.addEventListener(OPEN_COOKIE_SETTINGS_EVENT, this.handleOpenSettings);
  }

  componentWillUnmount() {
    window.removeEventListener(OPEN_COOKIE_SETTINGS_EVENT, this.handleOpenSettings);
  }

  syncVisibility = () => {
    this.setState({ visible: getConsent() === null });
  };

  handleOpenSettings = () => {
    this.setState({ visible: true });
  };

  handleAccept = () => {
    setConsent('accepted');
    enableAnalyticsConsent();
    this.setState({ visible: false });
  };

  handleReject = () => {
    setConsent('rejected');
    disableAnalyticsConsent();
    this.setState({ visible: false });
  };

  render() {
    if (!this.state.visible) {
      return null;
    }

    return (
      <div
        className="consent-banner"
        role="dialog"
        aria-modal="false"
        aria-labelledby="consent-banner-title"
        aria-describedby="consent-banner-desc"
      >
        <div className="consent-banner-inner container">
          <div className="consent-banner-copy">
            <p id="consent-banner-title" className="consent-banner-title">
              Cookie preferences
            </p>
            <p id="consent-banner-desc" className="consent-banner-text mb-0">
              We use essential cookies to run this site and optional analytics
              cookies (Google Analytics) to understand how visitors use it.
              Analytics stay off until you accept.{' '}
              <Link to="/privacy#cookies">Learn more</Link>
            </p>
          </div>
          <div className="consent-banner-actions">
            <Button
              type="button"
              color="primary"
              wideMobile
              onClick={this.handleReject}
            >
              Reject
            </Button>
            <Button
              type="button"
              color="secondary"
              wideMobile
              onClick={this.handleAccept}
            >
              Accept
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default ConsentBanner;
